module.exports = __webpack_public_path__ + "static/Rathausplatz2-4a4c59db381cd672a7ea5ff261d0919b.JPG";